// extracted by mini-css-extract-plugin
module.exports = {"alignButtonRight":"TabFormEdit_alignButtonRight__2x0Gj","listLight":"TabFormEdit_listLight___UDjC"};